import GenerationStatus from '../GenerationStatus';

interface AgencyAgreementSubmissionGeneratingProps {
  generationStatus: GenerationStatus;
}

const AgencyAgreementSubmissionGenerating = ({
  generationStatus,
}: AgencyAgreementSubmissionGeneratingProps) => {
  if (generationStatus === GenerationStatus.Generating) {
    return 'Submitting New Agreement';
  }

  if (generationStatus === GenerationStatus.Generated) {
    return 'Success';
  }
};

export default AgencyAgreementSubmissionGenerating;
